// extracted by mini-css-extract-plugin
module.exports = {"container":"UCPagination_container__3DVVv","btnprevnext":"UCPagination_btnprevnext__3FIlO","btnpages":"UCPagination_btnpages__HA7EN"};